'use client';

import { MapAddressFragment } from '@/__generated__/graphql';
import { Button } from '@/components/Atoms/Button';
import { Entry } from '@/lib/getters/getEntry';
import { parseLinkField } from '@/lib/parsers/linkField';
import dayjs from 'dayjs';

export const googleMapsDirectionsLink = (lat: number | string, lng: number | string) => {
  return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
};

export interface EventDetailProps {
  startDate?: Entry['startDate'];
  startTime?: Entry['startTime'];
  address?: MapAddressFragment | null;
  ticketsCta?: Entry['ticketsCta'];
}

export const EventDetail: React.FC<EventDetailProps> = ({
  startTime,
  address,
  ticketsCta,
  startDate,
}) => {
  const eventLink = parseLinkField(ticketsCta);
  return (
    <div className="rounded-3xl bg-accent p-8">
      <h4 className="mb-6">Event details</h4>
      {startDate && (
        <p className="mb-2">
          <strong>Date:</strong> {dayjs(startDate).format('D MMMM, YYYY')}
        </p>
      )}
      {startTime && (
        <p className="mb-2">
          <strong>Time:</strong> {dayjs(startTime).format('h:mma')}
        </p>
      )}
      {address && (
        <p className="mb-2">
          <strong>Location:</strong> {address?.formatted || 'TBC'}
        </p>
      )}
      {address?.lat && address?.lng && (
        <p className="mb-2">
          <a
            href={googleMapsDirectionsLink(address.lat, address.lng)}
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-blue-500 underline">
            Get directions
          </a>
        </p>
      )}
      {eventLink && (
        <div className="mt-6">
          <Button
            href={eventLink.href}
            color="darkGreen"
            arrow
            size="medium"
            target="_blank"
            rel="noopener noreferrer">
            {eventLink.children || 'Get tickets'}
          </Button>
        </div>
      )}
    </div>
  );
};
